import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from './authStore'

/**
 * Solo administradores autenticados acceden al panel. Un empleado con
 * credenciales válidas queda fuera: su acceso es la app móvil.
 */
export function ProtectedRoute() {
  const location = useLocation()
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated())
  const user = useAuthStore((state) => state.user)

  if (!isAuthenticated) {
    // `state.from` permite volver a la página pedida después del login.
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/login" replace state={{ reason: 'not-admin' }} />
  }

  return <Outlet />
}
